import React from 'react';
import { Card as RMCard, CardBody, CardHeading } from 'react-magma-dom';
import { CardProps as RMCardProps } from 'react-magma-dom/dist/components/Card';

export interface CardProps extends RMCardProps {
  heading?: React.ReactNode;
}

// Strictly visual (for now). Pulled into own component in case need to add customization later.
// If customization is added, testing should be added.
/** istanbul ignore next */
export const Card: React.FC<CardProps> = props => {
  const { heading } = props;

  return (
    <RMCard {...props}>
      <CardBody>
        {heading && <CardHeading>{heading}</CardHeading>}
        {props.children}
      </CardBody>
    </RMCard>
  );
};
